import { combinedBoundsFromRects } from '../canvasDragMirrorDom';

export function resolveBlockDragMirrorElement(
  contentSource: HTMLElement,
): HTMLElement {
  const directTable = contentSource.firstElementChild;
  if (!(directTable instanceof HTMLTableElement)) {
    return contentSource;
  }

  const padCell =
    directTable.querySelector('tbody > tr > td') ??
    directTable.querySelector('tr > td');
  if (!(padCell instanceof HTMLElement)) {
    return contentSource;
  }

  const inner = padCell.firstElementChild;
  if (inner instanceof HTMLElement) {
    return inner;
  }

  return padCell;
}

export function blockDragMirrorClientDelta(frame: HTMLElement): {
  x: number;
  y: number;
} {
  const content = frame.querySelector('[data-frame-content]');
  if (!(content instanceof HTMLElement)) {
    return { x: 0, y: 0 };
  }

  const mirror = resolveBlockDragMirrorElement(content);
  const frameRect = frame.getBoundingClientRect();
  const mirrorRect = mirror.getBoundingClientRect();

  return {
    x: mirrorRect.left - frameRect.left,
    y: mirrorRect.top - frameRect.top,
  };
}

function frameElement(level: 'block' | 'row', entityId: string): HTMLElement | null {
  if (typeof globalThis.document === 'undefined') {
    return null;
  }
  const frame = globalThis.document.querySelector(
    `[data-entity-id="${level}:${entityId}"]`,
  );
  return frame instanceof HTMLElement ? frame : null;
}

export function blockGhostClientDelta(blockId: string): { x: number; y: number } {
  const frame = frameElement('block', blockId);
  return frame ? blockDragMirrorClientDelta(frame) : { x: 0, y: 0 };
}

export function multiDragMirrorClientDelta(
  level: 'block' | 'row',
  entityIds: readonly string[],
  activeEntityId: string,
): { x: number; y: number } {
  const frames = entityIds
    .map(id => frameElement(level, id))
    .filter((frame): frame is HTMLElement => frame !== null);
  const combined = combinedBoundsFromRects(
    frames.map(frame => frame.getBoundingClientRect()),
  );
  const activeFrame = frameElement(level, activeEntityId);
  if (!combined || !activeFrame) {
    return { x: 0, y: 0 };
  }

  const activeRect = activeFrame.getBoundingClientRect();
  const contentDelta =
    level === 'block'
      ? blockDragMirrorClientDelta(activeFrame)
      : { x: 0, y: 0 };

  return {
    x: combined.left - activeRect.left + contentDelta.x,
    y: combined.top - activeRect.top + contentDelta.y,
  };
}
